// extracted by mini-css-extract-plugin
export default {"hist-bck":"History_hist-bck__c0duU","title1":"History_title1__HTF7o","title2":"History_title2__u2ylH","list-product":"History_list-product__kgSiC"};